export default class ImgInfo {
  constructor(props) {
    this.imgId = props.imgId
    this.imgSrc = props.imgSrc
  }
}